<!-- Notification Component Itself, Loading Spinner and Display -->
<div
	class="notifications-scroll-container"
	infinite-scroll
	[scrollWindow]="false"
	(scrolled)="onScrollDown()"
>
	<div class="row">
		@if (showFilter) {
			<div class="col-6 notification-type-dropdown">
				<ea-dropdown-icon-item
					[notificationTypeOptions]="notificationTypeOptions"
					[selectedTypeValue]="selectedNotificationFilterType"
					[hasSelectedTypeValue]="hasSelectedTypeValue"
					[selectedNotificationFilterIcon]="selectedNotificationFilterIcon"
					[dropdownId]="constants.dropdownIds.notificationTypesList"
					(onChange)="onNotificationTypeChange($event)"
				></ea-dropdown-icon-item>
			</div>
		}
		@if (hasNotifications && !isAdminNotification) {
			<div class="col d-flex justify-content-end mark-all-read">
				<ea-button-link
					(onClick)="markAllAsRead()"
					data-cy="mark-all-read-notifications-button-link"
				>
					Mark All As Read
				</ea-button-link>
			</div>
		}
	</div>
	@if (!hasNotifications && !showBulkReview) {
		<div>
			<span class="d-flex justify-content-center notifications-not-found">
				{{ constants.NOTIFICATIONS.NOTIFICATIONS_NOT_FOUND }}
			</span>
		</div>
	}

	<!-- BulkReviewApp -->
	@if (showBulkReview) {
		<ea-review-applications-appeals
			[bulkAppReviewCount]="bulkAppReviewCount"
		></ea-review-applications-appeals>
	}
	<!-- Announcements and Notifications-->
	@if (notificationItems?.length) {
		<div>
			@for (
				notificationItem of notificationItems;
				track notificationItem.id;
				let index = $index
			) {
				<div>
					@if (notificationItem.type === NOTIFICATION_ITEM_TYPE.ANNOUNCEMENT) {
						<div>
							<ea-announcements
								[announcementContent]="
									announcementContents[notificationItem.index]
								"
								[announcementRead]="
									isAnnouncementRead(
										announcementContents[notificationItem.index].id
									)
								"
								[isAdminNotification]="isAdminNotification"
								(markAsRead)="
									markAnnouncementAsRead(
										announcementContents[notificationItem.index].id
									)
								"
							>
							</ea-announcements>
						</div>
					}
					@if (notificationItem.type === NOTIFICATION_ITEM_TYPE.NOTIFICATION) {
						<div>
							<ea-application-event-notification
								[notification]="notifications[notificationItem.index]"
								[isAdminNotification]="isAdminNotification"
								class="notification-data"
							>
							</ea-application-event-notification>
						</div>
					}
				</div>
			}
		</div>
	}
	<ea-loading-container [loading]="isLoading && !!notifications.length">
	</ea-loading-container>
</div>
